<template>
    <div class="honor-detail">
        <div class="title">{{detail.title}}</div>
        <div class="time">{{ detail.created_at }}</div>
        <div class="content" v-html="detail.content"></div>
        <div class="global-back">
            <img src="/static/third/detail_back_btn.svg" @click="goList" alt="">
        </div>
    </div>
</template>

<script>
import Interface from "@/util/interface"

export default {
    name: 'topic-honor',
    data() {
        return {
            topic_id: 0,

            value: "",
            active: "",
            category_id: 0,
            category_index: 0,
            category_child_id: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            loading: true,
            topic: {},
            nav_active: 0,
            from_name: "",
            detail:{
                cover_img:[]
            },
        }
    },
    methods: {
        fetchTopic() {
            Interface.getData('get', Interface.topic.detail + this.$route.params.topic_id).then((res) => {
                this.topic = res.data
                let title = ""
                this.topic.modules.forEach(val => {
                    if (val.key == "honorary") {
                        title += val.title
                    }
                })
                let desc = ""
                switch (this.topic.id) {
                    case 2:
                        desc = "一站式解锁诊断技术发展动态，行业专家亲身传授，与数万名同道共成长"
                        break
                    default:
                        desc = this.topic.desc
                        break
                }

                Interface.getShareInfo(this, this.topic.title + "-" + title, this.topic.cover_img, desc)
            })
        },
        fetch(scene) {
            if (scene === 'detail') {
                Interface.getData('get', Interface.topic.honor_detail+this.$route.params.id).then((res) => {
                    if (res.code == 0) {
                        this.detail = res.data
                    }
                    setTimeout(() => {
                        this.loading = false;
                    }, 500)
                })
            }
        },
        changeCategory() {
            this.category_id = this.categories[this.category_index].id
            this.fetch('list')
        },
        goList() {
            this.$router.push({
                name: "topic-honor",
                params: {
                    topic_id: this.$route.params.topic_id
                }
            })
        }
    },
    created() {
        this.fetch('detail')
        this.fetchTopic()
        sessionStorage.removeItem("search_data")
    },
}
</script>

<style lang="scss">
@import './detail.scss';
</style>



// WEBPACK FOOTER //
// src/views/topic/honor/detail/detail.vue